import { SwivlChat } from "@swivl-mono/chat";
import { Channel, DefaultEmbedConfig, From, IsSessionTakenOver, MessageInterface, SessionInterface, UserInterface } from "@swivl-mono/types";
import { Spinner } from "@swivl-mono/ui";
import { AnimatePresence, motion } from "motion/react";
import { useEffect, useState } from "react";

import { AIModel } from "../../../../Models/AI/AI.Model";
import { Member } from "../../../../Models/Member/Member.Current";
import { UserConversationsInterface } from "../../../../Models/Users/Users.Model";
import { MultiChannelChatSectionEmptyState } from "./MultiChannelChatSectionEmptyState";

interface MultiChannelChatSectionProps {
  channel: Channel;
  chatRef: React.RefObject<any>;
  user: UserInterface;
  conversation?: UserConversationsInterface;
  isAutoCompleteEnabled?: boolean;
}

export function MultiChannelChatSection({ channel, chatRef, conversation, user, isAutoCompleteEnabled }: MultiChannelChatSectionProps) {
  const { currentConversationAIAutocompleteUserId } = AIModel.useState((s) => s);
  const [isEmpty, setIsEmpty] = useState<boolean | undefined>(undefined);

  const session: SessionInterface | undefined = conversation?.sessions?.[channel] || undefined;

  const paddingBottom = 16;
  const showEmptyState = isEmpty && !IsSessionTakenOver(session) ? true : false;

  const config: any = DefaultEmbedConfig;

  useEffect(() => {
    AIModel.setCurrentConversationAIAutocompleteUserId(user?.id);
  }, [user?.id]);

  const auth = {
    userId: user.id,
    from: From.AGENT,
    orgId: Member.orgId,
    memberId: Member.id,
    token: user.token || "",
    channel: channel
  };
  console.log("auth :", auth);
  const chatKey = `chat-${channel}-user-${user.id}`;
  console.log("chat key :", chatKey);
  return (
    <AnimatePresence mode="wait">
      <motion.div
        animate={{ paddingBottom: paddingBottom }}
        initial={{ paddingBottom: 0 }}
        className="flex min-h-0 w-full flex-1 flex-col gap-2"
        transition={{ duration: 0.2, ease: "easeInOut" }}
      >
        {!user || !user.token ? (
          <Spinner />
        ) : (
          <>
            <MultiChannelChatSectionEmptyState currentChannel={channel} hide={!showEmptyState} />
            <div
              className="flex size-full flex-col items-center justify-center overflow-y-auto"
              style={{ display: showEmptyState ? "none" : "flex" }}
            >
              <SwivlChat
                key={chatKey}
                auth={auth}
                from={From.AGENT}
                transcriptOnly={session ? false : true}
                canTakeOver={true}
                isConversationTakenOver={IsSessionTakenOver(session)}
                channel={channel}
                // takeoverConversation={takeoverConversation}
                config={config}
                server={import.meta.env.VITE_SERVER_URL}
                webSocketServer={import.meta.env.VITE_CHANNELS_WEBSOCKET_URL}
                messagingServer={import.meta.env.VITE_MESSAGING_SERVER_URL}
                commandCallback={(command: string) => {}}
                generateCSS={true}
                isOpen={true}
                isMobile={false}
                hideForm={true}
                parentControlsStart={false}
                loadPastMessagesBeforeConnect={true}
                showSystemEvents={true}
                ref={chatRef}
                // canTakeoverViaSMS={canTakeoverViaSMS}
                onConversationTranscriptUpdate={(transcript: MessageInterface[], fromInitialLoad: boolean) => {
                  if (fromInitialLoad && (!transcript || transcript.length === 0)) {
                    setIsEmpty(true);
                  } else if (isEmpty && transcript && transcript.length > 0) {
                    setIsEmpty(false);
                  }
                  // TODO: there was a hassentmessage condition to this conditional prior == investigate what it did
                  if (isAutoCompleteEnabled && user && user.id === currentConversationAIAutocompleteUserId) {
                    AIModel.onConversationTranscriptUpdate(transcript, user.id);
                  }
                }}
              />
            </div>
          </>
        )}
      </motion.div>
    </AnimatePresence>
  );
}
